import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import auth from "./modules/auth";
import config from "./modules/config";
import loading from "./modules/loading";
import notif from "./modules/notif";
import progreso from "./modules/progreso";

Vue.use(Vuex);
const vuexLocalStorage = new VuexPersist({
    strictMode: true, // This **MUST** be set to true
    key: 'vuex',
    storage: window.localStorage
});

export default new Vuex.Store({
    plugins: [vuexLocalStorage.plugin],
    modules: {auth, config, loading, notif, progreso},
    strict: true,
    mutations: {
        RESTORE_MUTATION: vuexLocalStorage.RESTORE_MUTATION // this mutation **MUST** be named "RESTORE_MUTATION"
    },
});


// WEBPACK FOOTER //
// ./resources/assets/js/store/index.js